import React from 'react';
import Button from '../../../components/Button';
import InputField from '../../../components/InputField';
import Typography from '../../../components/Typography';
import { emailIsValid } from '../../../utils';
import './login.scss';
import { NotificationActionType, NotificationContext } from '../../../components/Notification/state';
import { AuthActionType, AuthContext } from '../../Authentication/state';
import { AuthService } from '../../../api';
import { getRedirectRoute } from '../../../components/AppRouter/PrivateRoute';
import { Link, useHistory, useLocation } from 'react-router-dom';

type login = {
    email: string;
    password: string;
};

type LocationState = {
    from: {
        pathname: string;
    }
};

const Login: React.FC = () => {

    const history = useHistory();
    const location = useLocation<LocationState>();
    const notificationDispatch = React.useContext(NotificationContext).notificationDispatch;
    const authDispatch = React.useContext(AuthContext).dispatch;
    const [isLoading, setIsLoading] = React.useState(false);
    const { from } = location.state ? location.state : {from: undefined};

    const initLogin: login = {
        email: '',
        password: '',
    };

    const [login, setLogin] = React.useState(initLogin);

    const handleLogin = () => {
        setIsLoading(true);
        AuthService.login(login.email, login.password)
            .then((response) => {
                new Promise((resolve) => {
                    localStorage.setItem('synnernation_token', response.accessToken);
                    authDispatch({ type: AuthActionType.LOGIN, payload: response });
                    notificationDispatch({
                        type: NotificationActionType.OPEN,
                        payload: {
                            text: `Welcome back ${response.fname}!`,
                            status: 'info',
                            autoClose: true,
                        },
                    });
                    setIsLoading(false);
                    resolve('OK');
                }).then(() => {
                    setIsLoading(false);
                    const redirectUrl:string = from ? from.pathname: getRedirectRoute(response.role);
                    history.push(redirectUrl);
                });
            })
            .catch((e) => {
                notificationDispatch({
                    type: NotificationActionType.OPEN,
                    payload: {
                        text: e.message,
                        status: 'error',
                        autoClose: true,
                    },
                });
                setIsLoading(false);
            });
    };
    const handleChange = (name: string, value: string): void => {
        setLogin({ ...login, [name]: value });
    };
    
    return (
        <div className="login-container paper">
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleLogin();
                }}
            >
                <Typography variant="title" weight={500} color="secondary">
                    LOGIN
                </Typography>
                <hr />
                <Typography variant="body" weight={600}>EMAIL ADDRESS</Typography>
                <InputField
                    onChange={handleChange}
                    name="email"
                    type="email"
                    error={login.email.length > 0 && !emailIsValid(login.email)}
                    errorText="Email is invalid"
                    required={true}
                />
                <Typography variant="body" weight={600}>PASSWORD</Typography>
                <InputField
                    onChange={handleChange}
                    name="password"
                    type="password"
                    required={true}
                />
                <div className="action-container">
                    <Typography variant="caption">
                        <Link to="/forgot-password"><span
                            className="text-action"
                        >
                            Forgot Password?
                        </span></Link>
                        <br/>
                        <Link to="/apply"><span
                            className="text-action"
                        >
                            Apply Now
                        </span></Link>
                    </Typography>
                    <Button
                        color="primary"
                        loading={isLoading}
                        type="submit"
                    >
                        Login
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default Login;
